import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { useEffect, useState } from "react"

const InteractiveTooltip = ({ children, label, ...rest }) => {
  // HACK ALERT: ideally we'd simply set the Popover trigger to "hover" and leave it at that.
  // This can result in the Popover displaying on mount in certain situations (like when mounted
  // in a modal). To work around that, setting trigger to "hover" only after the Popover has mounted.
  const [trigger, setTrigger] = useState()
  useEffect(() => setTrigger("hover"), [])

  // Let's try just using the Tooltip instead.
  // NOTE: Chakra v3 does not support trigger prop! Only works with
  // click events. Use HoverCard for hover tooltips (TODO).
  return (
    <Tooltip title={label} popover={{ trigger }} {...rest}>
      {children}
    </Tooltip>
  )
}

export default InteractiveTooltip
